// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.FoodTooltip--container--SEIWY {
  opacity: 1;
  display: flex;
  flex-direction: column;
  min-width: 80px;
  margin: 2px 0;
  max-width: 180px;
}

.FoodTooltip--row--QPJLq {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  line-height: 20px;
}

.FoodTooltip--row--QPJLq:last-child {
  margin-bottom: -2px;
}

.FoodTooltip--label--Z6twW {
  flex-grow: 1;
}

.FoodTooltip--value--wrmvr {
  margin-left: 20px;
}

.FoodTooltip--units--LUPjT {
  min-width: 0.7em;
  margin-left: 10px;
}

.FoodTooltip--title--futzg {
  text-align: right;
}

.FoodTooltip--carb--MRoFo {
  font-weight: bold;
}

.FoodTooltip--divider--iwKpw {
  background-color: var(--bolus);
  height: 3px;
  margin: 9px -12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/daily/foodtooltip/FoodTooltip.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAGF;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;AACnB","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n@import '../../../styles/colors.css';\n\n.container {\n  opacity: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 80px;\n  margin: 2px 0;\n  max-width: 180px;\n}\n\n.row {\n  composes: smallSize from '../../../styles/typography.css';\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  line-height: 20px;\n}\n\n.row:last-child {\n  margin-bottom: -2px;\n}\n\n.label {\n  flex-grow: 1;\n}\n\n.value {\n  margin-left: 20px;\n}\n\n.units {\n  min-width: 0.7em;\n  margin-left: 10px;\n}\n\n.title {\n  composes: smallSize from '../../../styles/typography.css';\n  text-align: right;\n}\n\n.carb {\n  composes: row;\n  font-weight: bold;\n}\n\n.divider {\n  background-color: var(--bolus);\n  height: 3px;\n  margin: 9px -12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FoodTooltip--container--SEIWY`,
	"row": `FoodTooltip--row--QPJLq ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"label": `FoodTooltip--label--Z6twW`,
	"value": `FoodTooltip--value--wrmvr`,
	"units": `FoodTooltip--units--LUPjT`,
	"title": `FoodTooltip--title--futzg ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"carb": `FoodTooltip--carb--MRoFo FoodTooltip--row--QPJLq ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"divider": `FoodTooltip--divider--iwKpw`
};
export default ___CSS_LOADER_EXPORT___;
